import React from 'react'
import styled from "styled-components"

const StyledImage = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
  cursor: ${props => props.cursor};
`

const Image = ({src = "", width = "auto", height = "auto", onClick = null, cursor = "auto"}) => {
    return <StyledImage src={src} width={width} height={height} onClick={onClick} cursor={cursor}/>
}

export default Image
